<template>
    <div class="borrow">
        <Table border :columns="columns12" :data="bannerList">
            <template slot-scope="{ row }" slot="status">
                <span v-if="row.status==1">{{$t('coin.already')}}{{$t('coin.open')}}</span>
                <span v-else>{{$t('coin.already')}}{{$t('coin.off')}}</span>
            </template>
            <template slot-scope="{ row }" slot="is_open">
                <span v-if="row.is_open==1">{{$t('coin.already')}}{{$t('coin.open')}}</span>
                <span v-else>{{$t('coin.already')}}{{$t('coin.off')}}</span>
            </template>
            <template slot-scope="{ row }" slot="is_deposit">
                <Tag color="green" v-if="row.is_deposit==1">{{$t('pay.is_ok')}}</Tag>
                <Tag color="red" v-else>{{$t('pay.is_no')}}</Tag>
            </template>
            <template slot-scope="{ row }" slot="is_withdraw">
                <Tag color="green" v-if="row.is_withdraw==1">{{$t('pay.is_ok')}}</Tag>
                <Tag color="red" v-else>{{$t('pay.is_no')}}</Tag>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <div class="op_btn">
                    <Button
                        v-if="row.is_deposit==0"
                        type="info"
                        size="small"
                        style="margin-right: 5px"
                        @click="openDepositModal(row)"
                    >{{$t('pay.shewei')}}{{$t('pay.is_deposit')}}</Button>
                    <Button
                        v-if="row.is_withdraw==0"
                        type="info"
                        size="small"
                        style="margin-right: 5px"
                        @click="openWithdrawModal(row)"
                    >{{$t('pay.shewei')}}{{$t('pay.is_withdraw')}}</Button>
                    <Button
                        v-if="row.is_open == 0"
                        type="success"
                        size="small"
                        style="margin-right: 5px"
                        @click="openModal(row)"
                    >{{$t('coin.open')}}</Button>
                    <Button
                        v-if="row.is_open == 1"
                        type="warning"
                        size="small"
                        style="margin-right: 5px"
                        @click="openModal(row)"
                    >{{$t('coin.off')}}</Button>
                </div>
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>

        <Modal
            v-model="showOkModal"
            :title="$t('coin.confirmOk')"
            @on-ok="change_staust(1)"
            @on-cancel="showOkModal=false"
        >
        </Modal>
        <Modal
            v-model="showCancelModal"
            :title="$t('coin.confirmCancel')"
            @on-ok="change_staust(0)"
            @on-cancel="showCancelModal=false"
        >
        </Modal>

        <Modal
            v-model="showDepositModal"
            :title="$t('pay.shewei')+$t('pay.is_deposit')"
            @on-ok="change_deposit_staust(0)"
            @on-cancel="showDepositModal=false"
        >
        </Modal>
        <Modal
            v-model="showWithdrawModal"
            :title="$t('pay.shewei')+$t('pay.is_withdraw')"
            @on-ok="change_withdraw_staust(0)"
            @on-cancel="showDepositModal=false"
        >
        </Modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            modalItem: {},
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            totalItems: 0,
            showOkModal: false,
            showCancelModal: false,
            showDepositModal: false,
            showWithdrawModal: false,
            columns12: [
                {
                    title: "ID",
                    width: 80,
                    key: "id",
                },
                {
                    title: this.$i18n.t('pay.title'),
                    width: 150,
                    key: "title",
                },
                {
                    title: this.$i18n.t('pay.min_coin'),
                    width: 100,
                    key: "mincoin"
                },
                {
                    title: this.$i18n.t('pay.max_coin'),
                    width: 100,
                    key: "maxcoin",
                },
                {
                    title: this.$i18n.t('pay.is_deposit'),
                    width: 100,
                    key: "is_deposit",
                    slot: "is_deposit"
                },
                {
                    title: this.$i18n.t('pay.is_withdraw'),
                    width: 100,
                    key: "is_withdraw",
                    slot: "is_withdraw"
                },
                {
                    title: this.$i18n.t('pay.is_open'),
                    width: 100,
                    key: "is_open",
                    slot: "is_open"
                },
                {
                    title: this.$i18n.t('action'),
                    slot: "action",
                    width: 320,
                    align: "center",
                    fixed:"right"
                }
            ],
            bannerList: []
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            this.$get(this.$path.pay_channel_list, {
                page: this.currentPage,
            }).then(res => {
                if (res.data) {
                    this.bannerList = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        openModal(row) {
          this.modalItem = row;
          if(this.modalItem.is_open == 1){
            this.showCancelModal = true;
          }else{
            this.showOkModal = true;
          }
        },
        openDepositModal(row) {
          this.modalItem = row;
          this.showDepositModal = true;
        },
        openWithdrawModal(row) {
          this.modalItem = row;
          this.showWithdrawModal = true;
        },
        change_staust(status) {
          this.$post(this.$path.change_pay_channel_status, {
              id: this.modalItem.id,
              status: status
          }).then(res => {
              if (res.success) {
                  this.$Message.success(this.$i18n.t('operateSuccess'));
                  this.loadData(this.currentPage);
              }
          });
        },
        change_deposit_staust(status) {
          this.$post(this.$path.change_pay_channel_deposit_status, {
              id: this.modalItem.id,
              status: status
          }).then(res => {
              if (res.success) {
                  this.$Message.success(this.$i18n.t('operateSuccess'));
                  this.loadData(this.currentPage);
              }
          });
        },
        change_withdraw_staust(status) {
          this.$post(this.$path.change_pay_channel_withdraw_status, {
              id: this.modalItem.id,
              status: status
          }).then(res => {
              if (res.success) {
                  this.$Message.success(this.$i18n.t('operateSuccess'));
                  this.loadData(this.currentPage);
              }
          });
        }
    }
};
</script>
<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
    .add_coin {
        float: right;
    }
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
.jt_img {
    width: 100%;
    img {
        width: 100%;
    }
}
.order_num {
    display: flex;
    flex-direction: row;
    .tit {
        width: 60px;
        color: #bab9b9;
    }
    .info {
        width: 200px;
    }
}
.sts_list {
    margin-top: 10px;
    .tit {
        width: 100px;
        color: #bab9b9;
    }
}
.op_btn {
    margin-top: 5px;
}
.op_btn:nth-child(2) {
    margin-bottom: 5px;
}
/*.radio_div {
     width: 25%;
}*/
.ivu-radio-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.red_color{
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/system/pay.vue